IntlMessageFormat.__addLocaleData({"locale":"ha","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ha-Arab","pluralRuleFunction":function (n,ord){if(ord)return"other";return"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ha-Latn","parentLocale":"ha"});
IntlMessageFormat.__addLocaleData({"locale":"ha-Latn-GH","parentLocale":"ha-Latn"});
IntlMessageFormat.__addLocaleData({"locale":"ha-Latn-NE","parentLocale":"ha-Latn"});
IntlMessageFormat.__addLocaleData({"locale":"ha-Latn-NG","parentLocale":"ha-Latn"});
